export const renderBooleanValueCell = (cellValue: number | boolean) => {
  return `${cellValue}`
}
